import { render, staticRenderFns } from "./Gallery202312.vue?vue&type=template&id=01ad01c2&scoped=true&"
import script from "./Gallery202312.vue?vue&type=script&lang=js&"
export * from "./Gallery202312.vue?vue&type=script&lang=js&"
import style0 from "./Gallery202312.vue?vue&type=style&index=0&id=01ad01c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ad01c2",
  null
  
)

export default component.exports